<template>
  <div id="app-shmu">
    <LmsMssComponent endpoint="getmetar" source="data_shmu" :show_header="true"  />
  </div>
</template>

<script>
import LmsMssComponent from "@/components/LmsMssComponent";

export default {
  name: 'app',
  components: {
    LmsMssComponent,
  }
}
</script>
